module.exports = __webpack_public_path__ + "img/front cover.8be8d514.jpg";